const Map = ({ collection, children }) => {
  if(!children) {
    return null;
  }

  if(Array.isArray(collection)) {
    return collection.map(item => {
      return children(item);
    });
  }

  return null;
}

export default Map;



// WEBPACK FOOTER //
// ./src/components/map.js